import GetAppIcon from "@mui/icons-material/GetApp";
import Visibility from "@mui/icons-material/Visibility";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from "material-react-table";
import { useMemo, useState } from "react";
import { getFormatoFechaExportacion } from "../../../../utils/datetimeUtils";
import { downloadCsv } from "../../../../utils/filesUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import { dateTimeAccesor } from "../../../commons/table/columns/accesors";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";
import { StyledUsers } from "../../../styled/users";

const nombresPrestador = (fila) => {
  if (Array.isArray(fila?.prestadores)) {
    return fila.prestadores.filter(Boolean);
  }
  return String(fila?.prestador || "")
    .split(",")
    .map((nombre) => nombre.trim())
    .filter(Boolean);
};

const AuditoriaPrestadoresTable = ({ data, loading, fetchData, onVerDetalle }) => {
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

  const columns = useMemo(() => [
    {
      header: "Fecha y hora",
      accessorKey: "fechaHora",
      accessorFn: dateTimeAccesor("fechaHora"),
    },
    {
      header: "Prestador",
      accessorKey: "prestador",
      size: 420,
      minSize: 320,
      filterFn: (row, columnId, value) =>
        nombresPrestador(row.original).some((nombre) =>
          nombre.toLowerCase().includes(value.toLowerCase()),
        ),
      Cell: ({ row }) => {
        const nombres = nombresPrestador(row.original);
        return (
          <Box display="flex" flexWrap="wrap">
            {nombres.length > 0 ? (
              nombres.map((nombre) => (
                <StyledUsers.StyledChip key={nombre} label={nombre} />
              ))
            ) : (
              <StyledUsers.EmptyText>Sin prestadores asociados</StyledUsers.EmptyText>
            )}
          </Box>
        );
      },
    },
    { header: "Usuario", accessorKey: "usuario" },
    { header: "Email", accessorKey: "email" },
    { header: "Nombre", accessorKey: "nombre" },
    { header: "IP", accessorKey: "ip" },
    { header: "Módulo", accessorKey: "modulo" },
    { header: "Acción", accessorKey: "accion" },
    { header: "Siniestro", accessorKey: "siniestro" },
    { header: "DNI", accessorKey: "numeroDocumento" },
    {
      header: "Acciones",
      id: "acciones",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Tooltip title="Ver detalle">
          <IconButton onClick={() => onVerDetalle(row.original)} size="small" color="inherit">
            <Visibility />
          </IconButton>
        </Tooltip>
      ),
    },
  ], [onVerDetalle]);

  const handleExportToCsv = () => {
    setIsDownloadingCsv(true);
    const encabezado = [
      "Fecha y hora",
      "Prestador",
      "Usuario",
      "Email",
      "Nombre",
      "IP",
      "Módulo",
      "Acción",
      "Siniestro",
      "DNI",
    ];
    const filas = (data || []).map((fila) => [
      getFormatoFechaExportacion(fila.fechaHora, "dd/MM/yyyy HH:mm:ss"),
      fila.prestador || "",
      fila.usuario || "",
      fila.email || "",
      fila.nombre || "",
      fila.ip || "",
      fila.modulo || "",
      fila.accion || "",
      fila.siniestro || "",
      fila.numeroDocumento || "",
    ]);
    const csvContent = `sep=,\n${[encabezado, ...filas].map((fila) => fila.join(",")).join("\n")}`;
    downloadCsv(csvContent, "AuditoriaPrestadores");
    snackbarUtils.success("La auditoría ha sido descargada con éxito.");
    setIsDownloadingCsv(false);
  };

  return (
    <MaterialReactTable
      {...tableConfig}
      columns={columns}
      data={data || []}
      initialState={{
        ...tableConfig.initialState,
        sorting: [{ id: "fechaHora", desc: true }],
      }}
      state={{ isLoading: loading || isDownloadingCsv }}
      renderTopToolbarCustomActions={() => (
        <Box m={0.5}>
          <TitleContainer title="Auditoría de Prestadores" fetchData={fetchData} />
        </Box>
      )}
      renderToolbarInternalActions={({ table }) => (
        <>
          <Tooltip title="Exportar CSV">
            <IconButton color="inherit" onClick={handleExportToCsv}>
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ToggleDensePaddingButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
        </>
      )}
    />
  );
};

export default AuditoriaPrestadoresTable;
